module.exports = __webpack_public_path__ + "static/media/galeryDoors2.778d5caa.jpg";